export default __webpack_public_path__ + "static/media/APRDOM2025.cb307045.png";